import type { VariantType } from '../../../../types';
import type { SiteNotificationItem } from '../../types';
import styles from './SiteNotification.module.scss';
import raffleStyles from './SiteNotification.raffle.module.scss';

export interface SiteNotificationProps {
  notifications: Array<SiteNotificationItem>;
  variant?: VariantType;
}

function SiteNotification({ notifications, variant = 'default' }: SiteNotificationProps) {
  // variantに応じてスタイルを決定
  // var(--color-primary) を使用しているため出し分ける
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  return (
    <div className={currentStyles.siteNotifications}>
      {notifications.map((item, index) => (
        <p
          key={`site_notification_${
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            index
          }`}
          className={currentStyles.notificationItem}
        >
          <a href={item.link} target='_blank' rel='noreferrer'>
            {item.title}
          </a>
        </p>
      ))}
    </div>
  );
}

export default SiteNotification;
